
import { useEffect, useState } from 'react';

export default function useIsExtraLarge(breakpointPx: number = 1600) {
  const [isExtraLarge, setisExtraLarge] = useState<boolean>(() =>
    (typeof window !== 'undefined' ? window.innerWidth > breakpointPx : false)
  );
  useEffect(() => {
    const onResize = () => setisExtraLarge(window.innerWidth > breakpointPx);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [breakpointPx]);
  return isExtraLarge;
}
